import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  // 获取标准码数据
  getStandardCodeData: {
    url: '/adminc/v1/config_manage/b_code/get_code_list',
    method: 'get'
  },

  getCodeNoToken: {
    url: '/api/v1/config/code/get_codes_list_no_token',
    method: 'post'
  }

}

export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/StandardCode/StandardCodeData.js